/**
 * Утилиты для работы с телефонными номерами
 */

/**
 * Очистка номера от всех символов кроме цифр и +
 */
export const cleanPhoneNumber = (phone) => {
  if (!phone) return '';
  return phone.replace(/[^\d+]/g, '');
};

/**
 * Нормализация номера телефона (8 -> +7)
 * Используется при сохранении
 */
export const normalizePhoneNumber = (phone) => {
  if (!phone) return '';

  // Очищаем от всех символов кроме цифр
  let cleaned = phone.replace(/\D/g, '');

  // Если начинается с 8 и длина 11 цифр - это российский номер
  if (cleaned.startsWith('8') && cleaned.length === 11) {
    cleaned = '7' + cleaned.slice(1);
  }

  // Добавляем + если начинается с 7
  if (cleaned.startsWith('7') && cleaned.length === 11) {
    return '+' + cleaned;
  }

  // Если номер без кода страны (10 цифр, начинается с 9)
  if (cleaned.length === 10 && cleaned.startsWith('9')) {
    return '+7' + cleaned;
  }

  // Возвращаем как есть с + если есть цифры
  if (cleaned.length > 0) {
    return '+' + cleaned;
  }

  return phone;
};

/**
 * Форматирование номера для отображения
 * Формат: +7 (916) 333 67 56
 */
export const formatPhoneDisplay = (phone) => {
  if (!phone) return '';

  // Очищаем от всех символов кроме цифр
  let cleaned = phone.replace(/\D/g, '');

  // Если начинается с 8 - меняем на 7
  if (cleaned.startsWith('8') && cleaned.length === 11) {
    cleaned = '7' + cleaned.slice(1);
  }

  // Российский номер (11 цифр, начинается с 7)
  if (cleaned.length === 11 && cleaned.startsWith('7')) {
    const country = '+7';
    const area = cleaned.slice(1, 4);
    const part1 = cleaned.slice(4, 7);
    const part2 = cleaned.slice(7, 9);
    const part3 = cleaned.slice(9, 11);
    return `${country} (${area}) ${part1} ${part2} ${part3}`;
  }

  // Номер без кода страны (10 цифр)
  if (cleaned.length === 10) {
    const area = cleaned.slice(0, 3);
    const part1 = cleaned.slice(3, 6);
    const part2 = cleaned.slice(6, 8);
    const part3 = cleaned.slice(8, 10);
    return `+7 (${area}) ${part1} ${part2} ${part3}`;
  }

  // Для других форматов возвращаем как есть
  return phone;
};

/**
 * Форматирование номера для ссылки tel:
 */
export const formatPhoneForLink = (phone) => {
  if (!phone) return '';
  const normalized = normalizePhoneNumber(phone);
  return normalized;
};

/**
 * Форматирование номера при вводе (на лету)
 * Формат: +7 (916) 333 67 56
 */
export const formatPhoneInput = (value) => {
  if (!value) return '';

  // Очищаем от всех символов кроме цифр
  let digits = value.replace(/\D/g, '');

  // Если начинается с 8 - меняем на 7
  if (digits.startsWith('8') && digits.length >= 1) {
    digits = '7' + digits.slice(1);
  }

  // Если нет цифр - возвращаем пустую строку
  if (digits.length === 0) return '';

  // Если первая цифра не 7 и не 8, и длина 10 цифр - добавляем 7
  if (!digits.startsWith('7') && digits.length <= 10 && digits.startsWith('9')) {
    digits = '7' + digits;
  }

  // Форматируем по частям
  let result = '+';

  // Код страны (7)
  if (digits.length >= 1) {
    result += digits.slice(0, 1);
  }

  // Код оператора (916)
  if (digits.length >= 2) {
    result += ' (' + digits.slice(1, Math.min(4, digits.length));
    if (digits.length >= 4) {
      result += ')';
    }
  }

  // Первые 3 цифры номера
  if (digits.length >= 5) {
    result += ' ' + digits.slice(4, Math.min(7, digits.length));
  }

  // Следующие 2 цифры
  if (digits.length >= 8) {
    result += ' ' + digits.slice(7, Math.min(9, digits.length));
  }

  // Последние 2 цифры
  if (digits.length >= 10) {
    result += ' ' + digits.slice(9, Math.min(11, digits.length));
  }

  return result;
};
